import { combineReducers } from 'redux';
import { reducer as hotjarReducer } from 'redux-hotjar';

import seo from './seo/seo';
import search from './search/search';
import lastSearch from './lastSearch/lastSearch';
import saveSearch from './saveSearch/saveSearch';
import results from './results/results';
import location from './location/location';
import user from './user/user';
import dashboard from './dashboard/dashboard';
import savedJobs from './savedJobs/savedJobs';
import peekDown from './peekDown/peekDown';
import lmis from './lmis/lmis';
import experiments from './experiments/experiments';

const logger = reducerFn => (prevState, action) => {
  const nextState = reducerFn(prevState, action);

  if (typeof window !== 'undefined' && window.REDUX_DEBUG) {
    const { type } = action;
    console.log({ type, action, prevState, nextState });
  }

  return nextState;
};

export default logger(combineReducers({
  seo,
  search,
  lastSearch,
  saveSearch,
  results,
  location,
  user,
  dashboard,
  savedJobs,
  peekDown,
  lmis,
  experiments,
  ...hotjarReducer()
}));



/** WEBPACK FOOTER **
 ** ./app/store/reducer.js
 **/